export enum EstatusRequisicion {
  PorAprobar = 'Por aprobar',
  Aprobada = 'Aprobada',
  Rechazada = 'Rechazada'
}
